export function tarifasPage() {
    return {
        isLoading: false,
        error: null,
        tarifa: null,
        clases: [],
        tramites: [],
        claseSeleccionada: '',
        tramiteSeleccionado: '',
        openTransito: true,
        openRunt: true,
        choicesClase: null,
        choicesTramite: null,
        
        // URLs y textos desde data attributes
        clasesUrl: '',
        tramitesUrl: '',
        costosUrl: '',
        clasePlaceholder: '',
        tramitePlaceholder: '',
        errorProceso: '',

        async init() {
            // Leer datos desde los atributos del elemento
            const dataset = this.$root.dataset;
            this.clasesUrl = dataset.clasesUrl || '';
            this.tramitesUrl = dataset.tramitesUrl || '';
            this.costosUrl = dataset.costosUrl || '';
            this.clasePlaceholder = dataset.clasePlaceholder || 'Seleccione una clase';
            this.tramitePlaceholder = dataset.tramitePlaceholder || 'Seleccione un trámite';
            this.errorProceso = dataset.errorProceso || 'Error al procesar la solicitud';
            
            this.isLoading = true;
            try {
                const response = await fetch(this.clasesUrl);
                if (!response.ok) throw new Error('No se pudieron cargar las clases.');
                
                const result = await response.json();
                
                // Manejar tanto el formato antiguo (array directo) como el nuevo formato (objeto con data)
                this.clases = result.data || result;
                
                this.$nextTick(() => this.initChoices());
            } catch (e) {
                this.error = e.message;
            } finally {
                this.isLoading = false;
            }
        },

        initChoices() {
            // Destruir solo si ya existen
            if (this.choicesClase) {
                this.choicesClase.destroy();
                this.choicesClase = null;
            }
            if (this.choicesTramite) {
                this.choicesTramite.destroy();
                this.choicesTramite = null;
            }

            const claseSelect = document.getElementById('clase-select');
            const tramiteSelect = document.getElementById('tramite-select');

            // Inicializar Choices para clase
            if (claseSelect) {
                this.choicesClase = new Choices(claseSelect, {
                    searchEnabled: false,
                    shouldSort: false,
                    itemSelectText: '',
                    placeholderValue: this.clasePlaceholder,
                    position: 'auto'
                });
                
                claseSelect.addEventListener('change', (e) => {
                    this.claseSeleccionada = e.detail.value || e.target.value;
                    this.fetchTramites();
                });
            }

            // Inicializar Choices para trámite solo si hay opciones
            if (tramiteSelect) {
                this.choicesTramite = new Choices(tramiteSelect, {
                    searchEnabled: true,
                    shouldSort: false,
                    itemSelectText: '',
                    placeholderValue: this.tramitePlaceholder,
                    closeDropdownOnSelect: true,
                    position: 'auto',
                    noResultsText: 'No se encontraron resultados',
                    noChoicesText: 'Seleccione una clase primero'
                });

                tramiteSelect.addEventListener('change', (e) => {
                    this.tramiteSeleccionado = e.detail.value || e.target.value;
                });
            }
        },

        initTramiteChoices() {
            // Inicializar solo el Choices de trámite (usado cuando cambian las opciones)
            const tramiteSelect = document.getElementById('tramite-select');
            if (!tramiteSelect) return;
            
            // Destruir el existente
            if (this.choicesTramite) {
                this.choicesTramite.destroy();
                this.choicesTramite = null;
            }

            // Crear nueva instancia con las opciones actualizadas
            this.choicesTramite = new Choices(tramiteSelect, {
                searchEnabled: true,
                shouldSort: false,
                itemSelectText: '',
                placeholderValue: this.tramitePlaceholder,
                closeDropdownOnSelect: true,
                position: 'auto',
                noResultsText: 'No se encontraron resultados',
                noChoicesText: 'Seleccione una clase primero'
            });

            tramiteSelect.addEventListener('change', (e) => {
                this.tramiteSeleccionado = e.detail.value || e.target.value;
            });
        },

        async fetchTramites() {
            this.tramiteSeleccionado = '';
            this.tramites = [];
            this.tarifa = null;
            
            if (!this.claseSeleccionada) {
                // Limpiar trámites sin destruir Choices
                if (this.choicesTramite) {
                    this.choicesTramite.clearChoices();
                    this.choicesTramite.setChoices([], 'value', 'label', false);
                }
                return;
            }
            
            this.isLoading = true;
            try {
                const response = await fetch(
                    `${this.tramitesUrl}?clase=${this.claseSeleccionada}`);
                if (!response.ok) throw new Error('No se pudieron cargar los trámites.');

                const result = await response.json();
                this.tramites = result.data || result;

                // Actualizar el select nativo primero
                this.updateSelectElement();
                
                // Luego reinicializar Choices con las nuevas opciones
                this.$nextTick(() => {
                    this.initTramiteChoices();
                });
            } catch (e) {
                this.error = e.message;
            } finally {
                this.isLoading = false;
            }
        },

        updateSelectElement() {
            const tramiteSelect = document.getElementById('tramite-select');
            if (!tramiteSelect) return;
            
            // Reconstruir las opciones del select nativo
            let html = `<option value="">${this.tramitePlaceholder}</option>`;
            this.tramites.forEach(t => {
                html += `<option value="${t.codigo}">${t.nombre}</option>`;
            });
            tramiteSelect.innerHTML = html;
        },

        async consultarTarifa() {
            if (!this.tramiteSeleccionado) return;
            this.isLoading = true;
            this.tarifa = null;
            this.error = null;
            try {
                const url =
                    `${this.costosUrl}?tramite=${this.tramiteSeleccionado}&clase=${this.claseSeleccionada}`;
                const response = await fetch(url);
                const result = await response.json();
                
                if (!response.ok || !result.success) {
                    throw new Error(result.message || this.errorProceso);
                }
                
                // La respuesta ahora viene en result.data
                this.tarifa = result.data || result;
                this.openTransito = true;
                this.openRunt = true;
                
                // Scroll suave hacia los resultados después de cargar
                this.$nextTick(() => {
                    const resultsArea = document.querySelector('.results-area');
                    if (resultsArea) {
                        resultsArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            } catch (e) {
                this.error = e.message || this.errorProceso;
            } finally {
                this.isLoading = false;
            }
        },

        get subtotalTransito() {
            if (!this.tarifa) return 0;
            return (this.tarifa.costos?.reduce((s, c) => s + (c.tari_valor || 0), 0) || 0) + (this.tarifa
                .valorEstampilla || 0);
        },
        get subtotalRunt() {
            if (!this.tarifa?.runt) return 0;
            return (this.tarifa.runt.valor_min || 0) + (this.tarifa.runt.valor_runt || 0);
        },
        get totalGeneral() {
            return this.subtotalTransito + this.subtotalRunt;
        },
        formatCurrency(v) {
            return new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP',
                minimumFractionDigits: 0
            }).format(v || 0);
        },
    };
}